export default "049b1470c8129793.png"